/**
 * Shared constants + helpers for the Projects page.
 */
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import MovieIcon from '@mui/icons-material/Movie';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import BuildIcon from '@mui/icons-material/Build';

export const KINDS = ['production', 'season', 'episode', 'segment', 'internal', 'other'];

export const KIND_LABEL = {
  production: 'Production',
  season: 'Season',
  episode: 'Episode',
  segment: 'Segment',
  internal: 'Internal',
  other: 'Other',
};

export const KIND_COLOR = {
  production: '#A78BFA',
  season:     '#8B5CF6',
  episode:    '#60A5FA',
  segment:    '#38BDF8',
  internal:   '#94A3B8',
  other:      '#CBD5E1',
};

export function kindIcon(kind, opened = false) {
  switch (kind) {
    case 'production': return MovieIcon;
    case 'season':     return LiveTvIcon;
    case 'episode':    return PlayCircleOutlineIcon;
    case 'segment':    return ContentCutIcon;
    case 'internal':   return BuildIcon;
    default:           return opened ? FolderOpenIcon : FolderIcon;
  }
}

export const STATUSES = ['active', 'on_hold', 'done', 'archived'];

export const STATUS_COLOR = {
  active:   '#4ADE80',
  on_hold:  '#FBBF24',
  done:     '#94A3B8',
  archived: '#64748B',
};

export function formatHours(h) {
  const n = Number(h || 0);
  if (n === 0) return '—';
  return n % 1 === 0 ? `${n}h` : `${n.toFixed(1)}h`;
}

export function formatMoney(amt) {
  const n = Number(amt || 0);
  if (n === 0) return '—';
  if (Math.abs(n) >= 1000) return `$${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
  return `$${n.toFixed(0)}`;
}

export function formatMoneyFull(amt) {
  const n = Number(amt || 0);
  return `$${n.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}

export function formatDate(iso) {
  if (!iso) return '';
  const d = typeof iso === 'string' ? iso.slice(0, 10) : '';
  return d;
}
